import Vue from 'vue'
import Router from 'vue-router'
import DefaultLayout from '../layouts/Default.vue'
import onlineTransactionLayout from '../layouts/OnlineTransactionLayout.vue'
import LandingPage from '../views/LandingPage.vue'
import SummaryAO from '../views/SummaryAccountOpening'
import TransactionsConfirmation from '../views/TransactionsConfirmation'
import Investment from '../views/Investment'
import Redemption from '../views/Redemption'
import Switching from '../views/Switching'
import Amendment from '../components/Amendment'
import Confirmed from '../components/Confirmed'
import Completed from '../components/Completed'
import AgentSelection from '../views/AgentSelection'
import Acknowledgement from '../views/AcknowledgmentContainer'

import Iinvest from '../views/I-invest.vue'
import MessageHolder from '../views/MessageHolder.vue'
import TransactSwitchRedeem from '../views/TransactSwitchRedeem.vue'
import ClientTransaction from '../views/ClientTransaction'
import ClientTransactionSwitch from '../views/ClientTransactionSwitching'
import Login from '../views/Login'
import LoginChecking from '../views/LoginCheck'
import MessageTrigger from '../views/MessageTrigger'
import Error from '../views/Error'
import Maintenance from '../views/maintenance'
import AhamMaintenance from '../views/AhamMaintenance'
import PageNotFound from '../views/PageNotFound'
import OnboardProcess from '../views/onboardProcess'

import test from '../views/NonComplianceBrowser'
import store from '../store'
import dayjs from 'dayjs'
import ResetPage from '../views/IAccessResetPage.vue'
import transaction from '../views/online/redemption/transaction.vue'
import onlineRedemption from '../views/online/redemption/Transaction_Redemption_stepper.vue'
//import Login from '../views/Login'

import VueI18n from 'vue-i18n'

// APIM
import httpClient from '../services/httpClient'
Vue.prototype.$httpClient = httpClient
store.$httpClient = httpClient // register here so this http instance could eb used in vuex also

Vue.use(VueI18n)

Vue.use(Router)
import { Loading} from 'quasar'
var apiCall = true;
var counter=1;
var incomingMsg;
async function requireAuth (to, from, next) {
    console.log(to)
    incomingMsg = to
    var _session = store.state.Login.Session
    var checking = dayjs().isBefore(_session)
    console.log("result: " + process.env.VUE_APP_APICONNECT)

  if(to.query.appId != undefined){
    if (checking) {
        store.dispatch('Logging',
        {
            typeid :'1', 
            appid : '2',
            str : 'Non Login, Incoming Data -> ' + to.path
        });

        next();
      }else{
 
       // store.commit("ResetToken");

      //  console.log("to --> "+to.query.appId)
     //   console.log(to)

       /*  console.log(store.state.Login.incomingAppID)
        store.commit('SetPath', to.name)
        next('/Login') */
        Loading.show({
            spinnerSize : 50
        })

         while(counter<5){
           await EmisFlow(next)
           .then(res=>{
                if((counter===4)&&(apiCall===false)){
                    store.dispatch('Logging',{
                        appid : '2',
                        typeid :'3', 
                        str : 'Application ID --> ' + to.query.appId + '-> Unable to retrieve API TOKEN' 
                    });
                next('/maintenance')
               // console.log('error ->' + counter)
                }

                store.state.Login.incomingAppID = to.query.appId
                store.dispatch('Logging',
                {
                    typeid :'1', 
                    appid : '2',
                    str : 'Login, Incoming Data -> ' + to.query.appId + " : " + to.path
                });
           })
            counter++
        }       
     } 
  } else{
    next('/Login')
  }
    
}

async function EmisFlow(Obj){

  return new Promise((resolve, reject) => {
      try{
          store.dispatch('GETEmisToken',{
              ApplicationId:incomingMsg.query.appId
          }).then(res=>{
            // set authorization header here 
            store.$httpClient.defaults.headers['Authorization'] = "Bearer " + store.state.Login.AkamaiToken
              
            if(res === true){
                  apiCall = true
                  counter = 4
                  //Loading.hide()
                  store.dispatch('GetEmisIC', {
                    ApplicationId: incomingMsg.query.appId,
                  }).then(res=>{
                      if(res== true){
                          
                          //data for account creation url data
                          var toPath = incomingMsg.path.replace("/","")
                          store.state.LanguageToLoad = incomingMsg.query.language
                          // console.log(toPath)
                          store.state.Login.TransactionData = "appId="+incomingMsg.query.appId+"&language="+incomingMsg.query.language+"&transaction="+toPath+"&ahamAppId=emis"
                           store.dispatch('checkIAccessLoginCredential',{data:store.state.AOD.PersonalInformation.tempIC})
                          .then(res=>{ 

                            /*   if(res==false){
                                  Loading.hide()
                                  store.commit('SetPath', incomingMsg.fullPath)
                                  Obj('/Login')
                                   
                              }else*/ if(res == true){ 

                                  Loading.hide()
                                  store.commit('SetPath', incomingMsg.fullPath)
                                  Obj('/Login')
                              /**/ }else{
                                  Loading.hide()
                                  Obj('/maintenance')
                              } 
                              
                              resolve(apiCall)
                           })/* */
                      }else{
                          Loading.hide()
                          Obj('/maintenance')
                      }
                  })  /**/
              }else{
                  Loading.hide()
                  apiCall = false
                  
                //  console.log("apiCall 12 - >" +apiCall)
                  resolve(apiCall)
                 // next('/maintenance')
              }
          })
      }catch(err) {
          
          Loading.hide()
          apiCall = false
          reject(apiCall)
        }
  })
  
}
/* beforeRouteLeave (to, from , next) {
    const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
    if (answer) {
      next()
    } else {
      next(false)
    }
  } */

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: "/",
            component: DefaultLayout,
            redirect: "/i-invest",
            children: [
                {
                    path: 'test',
                    name: 'test',
                    component: test
                },
               {
                    path: 'LandingPage',
                    name: 'AHAM Investment',
                    component: LandingPage
                }, 
                {
                    path: 'IAccessResetPage',
                    name: 'IAccessResetPage',
                    component: ResetPage    
                },

                {
                    path: 'login',
                    name: 'AHAM Login',
                    component: Login  
                },
                {
                    path: 'LoginChecking',
                    name: 'AHAM Login Checking',
                    component: LoginChecking  
                },{
                    path: 'MessageHolder',
                    name: 'MessageHolder',
                    component: MessageHolder  
                },
                
                {
                    path: 'buy',
                    name: 'Investment',
                    component: Investment,
                    beforeEnter: requireAuth
                   
                },
                {   
                    path: 'redeem',
                    name: 'Redemption',
                    component: Redemption,
                    beforeEnter: requireAuth
                },
                {
                    path: 'switch',
                    name: 'Switching',
                    component: Switching,
                    beforeEnter: requireAuth
                },
                {
                    path: 'agentselection',
                    name: 'Agent Delection',
                    component: AgentSelection    
                },
               // {
                   // path: '/Transact',
                 //   name: 'Transact',
                    //component: Transact    
                //},
                {
                    path: '/i-invest',
                    name: 'Iinvest',
                    component: Iinvest    
                },
                {
                    path: '/Transact',
                    name: 'TransactSwitchRedeem',
                    component: TransactSwitchRedeem    
                },
                
                {
                    path: 'ClientTransaction',
                    name: 'ClientTransaction',
                    component: ClientTransaction    
                },
                {
                    path: 'ClientTransactionSwitch',
                    name: 'ClientTransactionSwitch',
                    component: ClientTransactionSwitch    
                },
                {
                    path: '/amendment',
                    name: 'Amendment',
                    component: Amendment    
                },
                {
                    path: 'confirmed',
                    name: 'Confirmed',
                    component: Confirmed    
                },
                {   
                    path: 'acknowledgement',
                    name: 'Acknowledgement',
                    component: Acknowledgement    
                },
                {   
                    path: 'MessageTrigger',
                    name: 'MessageTrigger',
                    component: MessageTrigger    
                },
                {   
                    path: 'error',
                    name: 'Error',
                    component: Error    
                },{   
                    path: 'maintenance',
                    name: 'Maintenance',
                    component: Maintenance    
                },
                {   
                    path: 'PageNotFound',
                    name: 'PageNotFound',
                    component: PageNotFound    
                },  
                {   
                    path: 'AhamMaintenance',
                    name: 'AhamMaintenance',
                    component: AhamMaintenance    
                },                
                {   
                    path: 'OnboardProcess',
                    name: 'OnboardProcess',
                    component: OnboardProcess    
                },
                
                {   
                    path: 'transaction',
                    name: 'transaction',
                    component: transaction    
                },
                {   
                    path: 'onlineRedemption',
                    name: 'onlineRedemption',
                    component: onlineRedemption    
                }                
            ],
            
            meta: {
                requiresAuth: true,
                permissions: ['liveview']
            }
        },
    ],
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
    /* routes: [
        {
            path: "/",
            component: onlineTransactionLayout,
            children: [
                {   
                    path: 'transaction',
                    name: 'transaction',
                    component: transaction    
                },
                {   
                    path: 'onlineRedemption',
                    name: 'onlineRedemption',
                    component: onlineRedemption    
                }

            ],
            meta: {
                requiresAuth: true,
                permissions: ['liveview']
            }
        }] */
})

/* router.beforeEach((to,from,next) =>{
    next();
}) */
  

export default router;